.mq-async-action-frame-pulsing {
  --mq-async-action-frame-pulse-color: var(--ant-color-primary-border);
  box-shadow: 0 0 0 0 var(--mq-async-action-frame-pulse-color);
  animation: mq-async-action-frame-pulse 1.8s ease-out infinite;
}

@keyframes mq-async-action-frame-pulse {
  0% {
    box-shadow: 0 0 0 0 var(--mq-async-action-frame-pulse-color);
  }

  70% {
    box-shadow: 0 0 0 var(--mq-space-xs, 8px) transparent;
  }

  100% {
    box-shadow: 0 0 0 0 transparent;
  }
}

@media (prefers-reduced-motion: reduce) {
  .mq-async-action-frame-pulsing {
    animation: none;
    box-shadow: 0 0 0 1px var(--mq-async-action-frame-pulse-color);
  }
}
